<template>
  <b-row class="mt-4 mb-2">
    <b-col xl="4">
      <h4>Observable Accounts</h4>
      <p class="small">Observable accounts are accounts that have either Agents given you access or you have added to your Team Users. You have the ability to view and/or edit their ClarityNOW portal.</p>
    </b-col>
    <b-col xl="8">
      <upgrade-overlay :title="'Observable Agents'" :upgradeImg="'dashboard.png'" :placeholderImg="'placeholders/observable-accounts.png'" v-if="!subscribed"></upgrade-overlay>
      <b-card no-body v-else>
        <b-card-header>
          <h3 class="mb-0">Observable Agents</h3>
        </b-card-header>
        <observable-table :tableData="items"></observable-table>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import ObservableTable from '@/views/Components/Tables/ObservableTable';
import UpgradeOverlay from '@/views/Components/Overlays/UpgradeOverlay';

export default {
  components: {
    ObservableTable,
    UpgradeOverlay
  },
  data: function() {
    return {
      items: null
    }
  },
  computed: {
    ...mapGetters({
      userRoute: 'profile/userRoute',
      subBasic: 'profile/subBasic',
      subStandard: 'profile/subStandard',
      subPremium: 'profile/subPremium'
    }),
    subscribed() {
      return this.subBasic || this.subStandard || this.subPremium;
    },
  },
  methods: {
    async getItems() {
      axios.get(this.userRoute + "/observable-users")
      .then(response => {
        this.items = response.data;
      });
    }
  },
  created() {
    this.getItems();
  },
};
</script>